import React, {useEffect, useState} from 'react';
import EmployeesInner from '../../Components/Companies/EmployeesInner';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import {getCompanyEmployeeInner} from '../../../redux/actions/employee/employeeActions';
import LoadPanel from '../../Components/LoadPanel';
import CompaniesHero from '../../Components/Companies/CompaniesHero';
import {useTranslation} from 'react-i18next';
import {getProjectMembersList} from '../../../redux/actions/projects/projectsActions';
import {mainPath} from '../../../routes/paths';

const ProjectParticipantsInnerEmployee = () => {
    const dispatch = useDispatch();
    const {userId} = useParams();
    const [btnLoading, setBtnLoading] = useState(false);
    const history = useHistory();

    const {profileMe} = useSelector((state) => state.profile);

    const {singleProject} = useSelector((state) => state.projects);

    const readPermission = hasPermission(PERMISSIONS.PERMISSION_VIEW, profileMe?.permissions ?? []);

    const editPermission = hasPermission(PERMISSIONS.PROJECT_EMPLOYEE_EDIT, profileMe?.permissions ?? []);
    const fireEmployeePermission = hasPermission(PERMISSIONS.EMPLOYEE_FIRE, profileMe?.permissions ?? []);
    const returnEmployeePermission = hasPermission(PERMISSIONS.EMPLOYEE_RETURN, profileMe?.permissions ?? []);
    const {companyEmployeesInner, companyEmployeesInnerLoading} = useSelector((state) => state.employee);
    const removePermission = hasPermission(PERMISSIONS.PROJECT_MEMBER_REMOVE, profileMe?.permissions ?? []);
    const allowActions = singleProject?.status === 'active' || singleProject?.status === 'pause'

    const {projectMembersList, projectMembersListLoading} = useSelector((state) => state.projects);

    const {t} = useTranslation();

    useEffect(() => {
        if (!projectMembersList.length && projectMembersListLoading) {
            dispatch(getProjectMembersList(singleProject.id));
        }
    }, [dispatch, singleProject.id, projectMembersListLoading, projectMembersList]);

    useEffect(() => {
        const fetch = async () => {
            if (userId) {
                try {
                    const res = await dispatch(getCompanyEmployeeInner(singleProject.companyId, userId));

                    if (!res.payload) {
                        handleBack();
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        };

        if (Object.keys(singleProject).length > 0) {
            fetch();
        }
    }, [singleProject, userId]);

    const handleAdd = () => {
        history.push(`${mainPath.projectsParticipantsAdd.replace(':id', singleProject?.id)}`);
    };

    const handleBack = () => {
        history.push(mainPath.projectsParticipants.replace(':id', singleProject?.id));
    };

    const addPermission = hasPermission(PERMISSIONS.PROJECT_MEMBER_ADD, profileMe?.permissions ?? []);
    const viewProjectPermission = hasPermission(PERMISSIONS.MEMBER_PROJECT_LIST, profileMe?.permissions ?? []);
    return (
        <div className={'projects-participants-wrapper'}>
            <div className='projects-participants'>
                <div className='projects-name'>{singleProject.address}</div>

                <CompaniesHero
                    heading={`${projectMembersList?.clients?.length + projectMembersList?.employees?.length} ${t(
                        'ProjectsParticipants.heading'
                    )}`}
                    subHeading={t('ProjectsParticipants.subHeading')}
                    selectedBack={true}
                    handleList={handleBack}
                    selectedList={true}
                    handleAdd={handleAdd}
                    disabledActionAdd={!addPermission || !allowActions}
                />
                {companyEmployeesInnerLoading || projectMembersListLoading ? (
                    <LoadPanel noBg={true} circleSize={40} staticPos={true}/>
                ) : (
                    <>
                        <EmployeesInner
                            companyId={singleProject.companyId}
                            companyEmployeesInner={companyEmployeesInner}
                            projectId={singleProject.id}
                            setBtnLoading={setBtnLoading}
                            btnLoading={btnLoading}
                            project={true}
                            handleList={handleBack}
                            readPermission={readPermission}
                            editPermission={editPermission && allowActions}
                            viewProjectPermission={viewProjectPermission}
                            fireEmployeePermission={fireEmployeePermission && allowActions}
                            returnEmployeePermission={returnEmployeePermission && allowActions}
                            removePermission={removePermission && allowActions}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default ProjectParticipantsInnerEmployee;
